export const login = {
  extends: 'Page',
  flow: 'y',
  align: 'center center',
  minHeight: '100vh',
  background: 'surface',
  padding: 'B',

  LoginCard: {
    flow: 'y',
    gap: 'B',
    padding: 'D',
    background: 'surfaceCard',
    border: '1px solid surfaceBorderStrong',
    borderRadius: 'A',
    width: '100%',
    maxWidth: 'H',
    '@mobileL': { padding: 'B', borderRadius: 'Z' },

    LogoLink: {
      extends: 'Link',
      href: '/',
      text: 'TrustLegal',
      fontSize: 'C',
      fontWeight: '800',
      color: 'green',
      textAlign: 'center',
      textDecoration: 'none',
    },
    LoginSubtitle: {
      text: '{{ loginSubtitle | polyglot }}',
      fontSize: 'A',
      color: 'textMuted',
      textAlign: 'center',
    },

    LoginTabs: {
      flow: 'x',
      gap: '0',
      borderRadius: 'Z',
      overflow: 'hidden',
      border: '1px solid surfaceBorderStrong',
      background: 'surfaceMid',
      LawyerTab: {
        extends: 'Button',
        text: '{{ loginLawyer | polyglot }}',
        flex: '1',
        padding: 'Z',
        fontSize: 'Z',
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '0',
        background: (el, s) => s.root.loginTab === 'lawyer' ? 'green' : 'transparent',
        color: (el, s) => s.root.loginTab === 'lawyer' ? 'black' : 'textSoft',
        fontWeight: (el, s) => s.root.loginTab === 'lawyer' ? '600' : '400',
        onClick: (e, el, s) => s.root.update({ loginTab: 'lawyer' }),
      },
      ClientTab: {
        extends: 'Button',
        text: '{{ loginClient | polyglot }}',
        flex: '1',
        padding: 'Z',
        fontSize: 'Z',
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '0',
        background: (el, s) => s.root.loginTab === 'client' ? 'green' : 'transparent',
        color: (el, s) => s.root.loginTab === 'client' ? 'black' : 'textSoft',
        fontWeight: (el, s) => s.root.loginTab === 'client' ? '600' : '400',
        onClick: (e, el, s) => s.root.update({ loginTab: 'client' }),
      },
    },

    LawyerForm: {
      tag: 'form',
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.loginTab === 'lawyer',
      EmailLabel: { tag: 'label', text: '{{ loginEmail | polyglot }}', fontSize: 'Z', color: 'textSoft', fontWeight: '500' },
      EmailInput: { tag: 'input', type: 'email', name: 'email', placeholder: 'name@firm.ge', padding: 'Z A', fontSize: 'A', background: 'surfaceMid', border: '1px solid surfaceBorderStrong', borderRadius: 'Z', color: 'text', width: '100%' },
      PassLabel: { tag: 'label', text: '{{ loginPassword | polyglot }}', fontSize: 'Z', color: 'textSoft', fontWeight: '500' },
      PassInput: { tag: 'input', type: 'password', name: 'password', placeholder: '••••••••', padding: 'Z A', fontSize: 'A', background: 'surfaceMid', border: '1px solid surfaceBorderStrong', borderRadius: 'Z', color: 'text', width: '100%' },
      SubmitLink: {
        extends: 'Link', href: '/dashboard', text: '{{ loginSubmit | polyglot }}',
        background: 'green', color: 'neutral950',
        padding: 'A', fontSize: 'A', fontWeight: '600', borderRadius: 'Z',
        width: '100%', textAlign: 'center', textDecoration: 'none',
        transition: 'transform 200ms',
        ':hover': { transform: 'scale(0.98)' },
        onClick: (e, el, s) => s.root.update({ loggedIn: true, userType: 'lawyer' }),
      },
    },

    ClientForm: {
      tag: 'form',
      flow: 'y',
      gap: 'A',
      show: (el, s) => s.root.loginTab === 'client',
      ClientEmailLabel: { tag: 'label', text: '{{ loginEmail | polyglot }}', fontSize: 'Z', color: 'textSoft', fontWeight: '500' },
      ClientEmailInput: { tag: 'input', type: 'email', name: 'email', placeholder: 'your@email.ge', padding: 'Z A', fontSize: 'A', background: 'surfaceMid', border: '1px solid surfaceBorderStrong', borderRadius: 'Z', color: 'text', width: '100%' },
      CaseNumLabel: { tag: 'label', text: '{{ loginCaseNumber | polyglot }}', fontSize: 'Z', color: 'textSoft', fontWeight: '500' },
      CaseNumInput: { tag: 'input', type: 'text', name: 'caseNum', placeholder: '#2024-047', padding: 'Z A', fontSize: 'A', background: 'surfaceMid', border: '1px solid surfaceBorderStrong', borderRadius: 'Z', color: 'text', width: '100%' },
      ClientSubmitLink: {
        extends: 'Link', href: '/client', text: '{{ loginSubmit | polyglot }}',
        background: 'green', color: 'neutral950',
        padding: 'A', fontSize: 'A', fontWeight: '600', borderRadius: 'Z',
        width: '100%', textAlign: 'center', textDecoration: 'none',
        transition: 'transform 200ms',
        ':hover': { transform: 'scale(0.98)' },
        onClick: (e, el, s) => s.root.update({ loggedIn: true, userType: 'client' }),
      },
    },

    Divider: {
      width: '100%',
      borderTop: '1px solid surfaceBorderStrong',
    },

    BackLink: {
      extends: 'Link',
      href: '/',
      text: '{{ loginBackLink | polyglot }}',
      textAlign: 'center',
      fontSize: 'Z',
      color: 'textMuted',
      textDecoration: 'none',
      ':hover': { color: 'green' },
    },
  },
}
